import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'

import { DebtorService } from '../_services/debtor.service'
import { PaymentProcessService } from '../_services';
import { PaymentProcess } from '../_models';
import { AuthService } from '../_services/auth.service';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';

@Component({
    selector: 'paymentdetail',
    templateUrl: './paymentdetail.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})



export class PaymentDetailComponent {

    public customer_public_id: string;

    payprocessPublic_key: any;

    titleName: string;
    status: string;

    accountname: string;
    reference: string;
    clientname: string;
    clientpublic_id: string;
    description: string;
    sub_total: string;
    late_fee: string;
    total: string;
    totalsymbol: string;
    external_id: string;
    created: string;
    due_datetime: string;
    expiration_datetime: string;
    public user_public_id: string;
    totalcurrency: string;
    totalcurrencyvalue: string;

    paymentProcess: PaymentProcess;

    payHistoricalListDataSource = new MatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginatorHistorical: MatPaginator;
    displayedColumns: string[] = ['created', 'description', 'name', 'username'];

    displayedColumnsInvoice: string[] = ['created', 'name', 'sub_total.value', 'late_fee.value', 'total.value'];
    dataSourceInvoicesList = new MatTableDataSource();
    @ViewChild(MatSort) sortInvoice: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    auth0Profile: any;

    constructor(
        private router: Router, private formBuilder: FormBuilder
        , private parameterData: ParameterData, private dataService: DataService
        , private readonly activatedRoute: ActivatedRoute
        , private paymentProcessService: PaymentProcessService
        , private debtorService: DebtorService
        , private auth: AuthService
    ) {


    }//end cosnt

    ngOnInit() {


        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');

            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        let params: any = this.activatedRoute.snapshot.params;
        this.payprocessPublic_key = params.id;

        this.GetIndividualPaymentProcessDetails();



    }//end

    GetIndividualPaymentProcessDetails() {
        this.paymentProcessService.getPaymentProcess(this.payprocessPublic_key).subscribe((data: PaymentProcess) => {
            this.paymentProcess = data;
            this.titleName = data.name;
            this.status = data.status;
            this.accountname = data.psp_operation.psp_account.name;
            this.external_id = data.external_id;
            this.reference = data.reference;
            this.description = data.description;
            this.clientname = data.debtor.name;
            this.clientpublic_id = data.debtor.public_id;
            this.late_fee = "0";
            this.sub_total = "0";
            this.total = data.total.value.toString();
            this.totalsymbol = data.total.symbol;

            this.created = data.created;
            this.due_datetime = "0";
            this.expiration_datetime = "0";
            this.totalcurrency = data.total.currency;

            this.getDebtorInvoiceList(data.debtor.public_id);

            this.dataSourceInvoicesList.data = data.invoice_list;
            this.payHistoricalListDataSource.data = data.activity_list;
        },
            error => {
                console.log('Failed while trying to get Individual payment Process Detail. ' + error);
            });

    }//end

    getDebtorInvoiceList(public_id: string) {

    }

    onCancelPaymentProcess() {
        this.paymentProcessService.cancelPaymentProcess(this.payprocessPublic_key, this.paymentProcess)
            .subscribe((result) => {
                this.router.navigate(['/payments']);
            }, error => {
                console.log('Failed while trying to cancel the payments Details.' + error);
            });
    }

    viewInvoiceDetails(id) {
        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
        }
    }

}//end


